export default {
  bind (el, binding) {
    const onclick = event => {
      event.stopPropagation();

      const name = binding.value.name;
      const offsetTop = binding.value.offsetTop;
      const to = document.querySelector(`[data-scroll-name="${name}"]`);

      if (!to) {
        return;
      }

      window.scroll({
        top: to.offsetTop - offsetTop || 0,
        left: 0, 
        behavior: 'smooth'
      });
    };
    
    el.addEventListener('click', onclick);
  }
};
